import { CircularProgress, Paper } from "@material-ui/core";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import CustomSearch from "../../Common/CustomSearch";
import ErrorMessage from "../../Common/ErrorMessage";
import userService from "../../services/user.service";
import { getFromLocalStorage } from "../../utils/webStorage";
import SuperAdminDashboard from "./superAdminDashboard";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
import { GridCheckCircleIcon } from "@mui/x-data-grid";
import ListMenu from "../../Common/ListMenu";
import DeleteIcon from "@mui/icons-material/Delete";
import { openConfirmationPopup } from "../../Redux/Actions/PopupActions";
import ClearIcon from "@mui/icons-material/Clear";
import { openFailDialog } from "../../Redux/Actions/PopupActions";
import {
  setBreakdownRequetsData,
  updateBreakdownRequestPage,
} from "../../Redux/Actions/BreakdownRequestsDataAction";

const Breakdown = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedRecord, setSearchedRecord] = useState(false);
  const [recordNotFound, setRecordNotFound] = useState(false);
  const loginRole = getFromLocalStorage("loginRole");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const breakdownRequestData = useSelector(
    (state) => state.BreakdownRequestData
  );

  useEffect(() => {
    getBreakdownRequestData();
  }, [breakdownRequestData?.page]);

  const handleApprove = (data) => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure, You Want To Approve Request?",
        btnColor: "green",
        btnText: "Yes",
        id: data.id,
        breakdownRequestData: breakdownRequestData,
        type: "Approve Breakdown Request",
      },
    });
  };

  const handleDisapprove = (data) => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure, You Want To Disapprove Request?",
        btnColor: "green",
        btnText: "Yes",
        id: data.id,
        breakdownRequestData: breakdownRequestData,
        type: "Disapprove Breakdown Request",
      },
    });
  };

  const tableColumns = [
    {
      field: "schoolName",
      headerName: "School Name",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => (
        <div className="d-flex-align-cent height-70 w-100 padding-left-10 padding-right-10">
          <p className="link-blue text-width-auto mg-auto">
            {typeof params.row.schoolName === "string"
              ? params.row.schoolName
              : ""}
          </p>
        </div>
      ),
    },
    {
      field: "firstName",
      headerName: "Coach Name",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 130,
      align: "center",
      renderCell: (params) => (
        <span>{`${params.row.firstName} ${params.row.lastName}`}</span>
      ),
    },
    {
      field: "breakdownName",
      headerName: "Breakdown Name",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 130,
      align: "center",
    },
    {
      field: "possibleValues",
      headerName: "Possible Values",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 130,
      align: "center",
    },
    {
      field: "approve",
      headerName: "Action",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 150,
      align: "center",
      renderCell: (params) => (
        <div className="actionContainer">
          {params.row.approve && (
            <span className="approved">
              <GridCheckCircleIcon fontSize="small" /> Approved
            </span>
          )}
          {params.row.disApprove && (
            <span className="disapproved">
              <ClearIcon className="clearIcon" fontSize="small" /> DisApproved
            </span>
          )}
          {!params.row.approve && !params.row.disApprove && (
            <>
              <button
                className="approve-bttn"
                onClick={() => handleApprove(params.row)}
              >
                Approve
              </button>
              <button
                className="disapprove-bttn"
                onClick={() => handleDisapprove(params.row)}
              >
                DisApprove
              </button>
            </>
          )}
        </div>
      ),
    },
    {
      headerClassName: "table-header bold",
      cellClassName: "mng-z-index2",
      headerAlign: "center",
      align: "center",
      sortable: false,
      height: 100,
      renderCell: (params) => (
        <div>
          <ListMenu
            menuContent={menuItemContent(params.row)}
            rowData={params.row}
          />
        </div>
      ),
    },
  ];

  const menuItemContent = (data) => {
    const notDeleted = [
      {
        id: "1",
        name: "Delete",
        icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
        ApiCall: () => deleteRequestDialog(data),
      },
    ];
    return notDeleted;
  };

  const deleteRequestDialog = (data) => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure, You Want To Delete Request?",
        btnColor: "red",
        btnText: "Yes",
        id: data.id,
        breakdownRequestData: breakdownRequestData,
        type: "Delete Breakdown Request",
      },
    });
  };

  const getBreakdownRequestData = () => {
    setLoading(true);
    userService
      .getBreakdownRequestsByPage(page, breakdownRequestData.size)
      .then((res) => {
        setBreakdownRequetsData(dispatch, res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  const handlePageChange = (page) => {
    updateBreakdownRequestPage(dispatch, page);
  };

  const searchBreakdownRequestData = (searchKeyword) => {
    setLoading(true);
    if (!searchedRecord) {
      setSearchedRecord(true);
    }
    userService
      .searchBreakdownRequest(searchKeyword)
      .then((response) => {
        setBreakdownRequetsData(dispatch, response.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  return (
    <>
      {loginRole === "SUPER ADMIN" ? (
        <div>
          <div className="content">
            <SuperAdminDashboard />
            <div className="content-layout">
              <div className="mng-header  ">
                <div className="fs-20 black bold ">
                  <h4 className="fs-24 bold mob-hd">
                    Breakdown Requests ({breakdownRequestData?.content?.length}){" "}
                  </h4>
                </div>
              </div>
              {loading && (
                <div className="content-layout-loading-animation">
                  <CircularProgress sx={{ fontSize: 10, color: "#002244" }} />
                </div>
              )}
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr pt-1">
                {!loading &&
                  (breakdownRequestData?.content?.length > 0 ||
                    breakdownRequestData.empty) && (
                    <Paper className="pad-top-20 mg-bottom-20">
                      <CustomSearch
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                        searchedRecord={searchedRecord}
                        setSearchedRecord={setSearchedRecord}
                        getDataByPage={getBreakdownRequestData}
                        searchData={searchBreakdownRequestData}
                      />
                      <DataGrid
                        rows={breakdownRequestData.content}
                        columns={tableColumns}
                        pageSize={breakdownRequestData.size}
                        page={breakdownRequestData.number}
                        pagination
                        rowCount={breakdownRequestData.totalElements}
                        onPageChange={(params) => handlePageChange(params)}
                        loading={loading}
                        rowsPerPageOptions={[breakdownRequestData.size]}
                        autoHeight
                        disableColumnMenu
                        getRowHeight={() => "auto"}
                        getRowId={(row) => row.id}
                        disableSelectionOnClick
                        sx={{
                          color: "black",
                          fontFamily: "Rajdhani-SemiBold",
                          fontSize: "18px",
                          backgroundColor: "white",
                          borderBottomLeftRadius: "12px",
                          borderBottomRightRadius: "12px",
                        }}
                        onCellClick={(params) => {
                          // logic
                        }}
                      />
                    </Paper>
                  )}
                {!loading &&
                  breakdownRequestData?.content?.length > 0 &&
                  !recordNotFound && <ErrorMessage />}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <PageNotFoundPage />
      )}
    </>
  );
};

export default Breakdown;
